import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const PerformanceInsightsPage = loadAsyncComponent(() => import('./Container'), 'page');
